import { ApolloProvider } from "@apollo/client/react";
import { createRoot } from "react-dom/client";

import { apolloClient } from "@/apollo/apolloClient";
import { ThemeProvider } from "@/components/context/ThemeContext";
import { IS_ME_LINK } from "@/constants/app";
import "@/i18n.ts";
import "@/styles/index.scss";

import App from "./App";

if (IS_ME_LINK) {
  document.documentElement.setAttribute("data-app-brand", "me-short-link");
  document
    .querySelector("link[rel='apple-touch-icon']")
    ?.setAttribute("href", "/favicon-link.ico");
  document
    .querySelector("link[rel='icon']:not([type])")
    ?.setAttribute("href", "/favicon-link.ico");
  document
    .querySelector("link[rel='icon'][type='image/png']")
    ?.setAttribute("href", "/favicon-link.png");
}

const root = createRoot(document.getElementById("root")!);

root.render(
  <ThemeProvider>
    <ApolloProvider client={apolloClient}>
      <App />
    </ApolloProvider>
  </ThemeProvider>
);
